// extracted by mini-css-extract-plugin
export default {"info":"_1AvD4","time":"UdDX3","title":"Qn36B","ellipsis":"eWy7X","more":"To7wb"};